import {ClickEvent} from "../../../../infrastructure/models/analytics/click-event";

export class BettingContainerDrawerMenuNavigationClickEvent extends ClickEvent {
  menuLevel: Number;
  position: Number;
  label: String;
  pageUrl: String;

  constructor(params: BettingContainerDrawerMenuNavigationClickEvent) {
    super('', 'click', 'menu_navigation');

    this.position = params.position;
    this.menuLevel = params.menuLevel;
    this.name = params.label;
    this.pageUrl = params.pageUrl;
    this.isApostas = true;
  }

  get properties() {
    const properties = super.properties;

    properties.position = this.position
    properties.menuLevel = this.menuLevel;
    properties.name = this.label
    properties.pageUrl = this.pageUrl
    properties.isApostas = this.isApostas

    return properties;
  }
}